import React, { Component } from "react";
import logo from "./logo.svg";
import Stories from "react-insta-stories";

// import { storyList } from "mock/stories";
import "../App/App.css";
import ReactInstaStoriesProps from "react-insta-stories";
import { useState } from "react";
import { EmojiDefault } from "components/SVG/svg";
import loveEmoji from "assets/love_emoji.png";
import nahEmoji from "assets/nah_emoji.png";
import mehEmoji from "assets/meh_emoji.png";
import defaultEmoji from "assets/defaultEmoji.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useEffect } from "react";
import { getStories, getStoryItem } from "store/async-actions/hive";
import {
  getStoriesListSelector,
  getStoryItemSelector,
  setStartClicked,
} from "store/reducers/hive";
import { OrganizationStoryObject } from "api/models/community";
import { Routes } from "routes/BaseRoute";

function Home() {
  const location = useLocation();

  const urlParams = location.search.split("?")[1];

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const storyItem = useAppSelector(getStoryItemSelector);

  const backgroundImage = storyItem?.storyUrl
    ? `url(${storyItem.storyUrl})`
    : "none";

  const handleClick = () => {
    navigate(`/story/${urlParams}`);
    localStorage.setItem("storyUuid", urlParams);
    dispatch(setStartClicked(true));
  };

  useEffect(() => {
    if (urlParams) {
      dispatch(getStories({ storyUuid: urlParams }));
      dispatch(getStoryItem({ storyUuid: urlParams }));
    }
  }, [dispatch, urlParams]);

  return (
    <div onClick={handleClick} className="home_wrap">
      <div
        className="black-screen"
        style={{
          backgroundImage,
        }}
      >
        <div className="overlay_screen"></div>
        <div className="story_click_btn">
          <h3>{storyItem?.storyTitle || "Discover more"}</h3>
          <h3>Click anywhere</h3>
        </div>
        {/* <button className="start-button">
          Start
        </button> */}
      </div>
    </div>
  );
}

export default Home;
